<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    icon="warning"
    hide-close-button
    @close="close"
  >
    <p>{{ $t('tags.delete_tags') }}</p>

    <template #button>
      <button class="btn btn-default right-margin" @click="closeModal">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ $t('modals.save_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';

export default {
  name: 'DeleteTagsModal',
  components: {
    SweetModal
  },
  computed: mapState({
    deleteTagsModal: state => state.deleteTagsModal,
    pendingTags: state => state.pendingTags
  }),
  methods: {
    ...mapMutations(['setDeleteTagsModal']),
    ...mapActions(['saveTags']),
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.setDeleteTagsModal(false);
    },
    closeModal() {
      this.$refs.modal.close();
    },
    save() {
      this.closeModal();
      const payload = {tags: this.pendingTags};
      this.saveTags(payload);
    }
  },
  watch: {
    deleteTagsModal(newVal) {
      if (newVal === true) {
        this.$refs.modal.open();
      }
    }
  }
};
</script>
<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
